import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Contestan según el humor del día', 'Se justifican por el precio antes de decirlo', "Mandan audios largos para 'explicar mejor'", 'Se quedan sin palabras cuando aparece una objeción', "Dejan el cierre para 'cuando el cliente esté listo' (nunca)"];
  return <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 text-center" data-id="element-155">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1A1A1A] mb-4" data-id="element-156">
            Y ahí es donde la mayoría pierde dinero sin darse cuenta
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-157">
            Si hoy vendes por Instagram, Facebook o WhatsApp, tu "caja
            registradora" real es el chat.
          </p>
        </motion.div>

        <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 shadow-sm mb-12" data-id="element-158">
          <ul className="space-y-4" data-id="element-159">
            {problems.map((problem, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-3" data-id="element-160">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-161" />
                <span className="text-lg text-gray-700" data-id="element-162">{problem}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-163">
          <h3 className="text-xl font-bold text-[#1A1A1A]" data-id="element-164">
            La verdad incómoda:
          </h3>
          <p className="text-2xl sm:text-3xl font-serif italic text-gray-800 leading-relaxed" data-id="element-165">
            "A veces tu negocio no está mal de marketing. <br data-id="element-166" />
            <span className="bg-green-100 px-2" data-id="element-167">Está mal de conversación.</span>
            "
          </p>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-168">
            Nadie te dio un sistema simple para guiar a una persona desde <br data-id="element-169" />
            <span className="font-bold text-[#1A1A1A]" data-id="element-170">
              "hola, quiero info"
            </span>{' '}
            hasta{' '}
            <span className="font-bold text-[#0B6B3A]" data-id="element-171">
              "listo, ¿cómo pago?"
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}